import React, { useEffect, useState } from 'react'
import SubServicesFilters from '../../AdvanceFilter'
import { FaAngleDown } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { getSelectedNames } from '../../../config/utils/getSelectedServicesNames';


const ServicesCustomSelectBox = (props) => {
    const { onChange, setServicesCustomError, servicesCustomError } = props
    const [servicesOpen, setServicesOpen] = useState(false)
    const [selectedServices, setSelectedServices] = useState([])
    const [editData, setEditData] = useState(props?.onEdit())

    const { services: allServices } = useSelector(state => state?.services);

    const servicesModalOpener = () => {
        setServicesOpen(true)
    }

    useEffect(() => {
        if (props?.isServicesFilled) {
            advanceFiltersValueHandler(props?.selectedFiltersValue)
        }
    }, [props?.isServicesFilled])

    const advanceFiltersValueHandler = (selectedServices) => {

        // we have to send the first parent id, second parent id and the third layer arrays item's
        // id on selection of any third layer of item.

        // all the values in the values array.
        let services = [];

        // only third layer selected values name in selectedValues array to show.
        let selectedValues = getSelectedNames(allServices, selectedServices);

        for (const key in selectedServices) {
            if (Object.keys(selectedServices[key]).length > 0) {
                for (const subServiceKey in selectedServices[key]) {
                    if (selectedServices[key][subServiceKey] && selectedServices[key][subServiceKey]?.length > 0) {
                        services.push(Number(subServiceKey))
                        services.push(Number(key))
                        services = [...services, ...selectedServices[key][subServiceKey]]
                        // this line commented because of showing only the third layers selected names.
                        // selectedValues = [...selectedValues, ...selectedServices[key][subServiceKey]]
                    }
                }
            }
        }

        services = [...new Set(services)];
        setSelectedServices(selectedValues)

        // let keys = Object.keys(selectedServices);
        // let hasValues = keys.some(key => Array.isArray(selectedServices[key]) && selectedServices[key].length > 0);

        if (selectedValues?.length > 0) {
            setServicesCustomError(false)
            onChange(services)
            return
        } else {
            setServicesCustomError(true)
            return
        }
    }

    // useEffect(() => {
    //     if (editData) {
    //         console.log(editData)
    //         setSelectedServices(editData.length)
    //     }
    // }, [editData])

    return (
        <>
            <div className={`${props?.classes} rounded-md flex-1 h-12 w-full flex items-center justify-between px-2 cursor-pointer ${servicesCustomError ? 'border border-red-600' : ''}`} onClick={servicesModalOpener}>
                <p className='text-[#181818] truncate'>
                    {
                        selectedServices?.length > 0 ?
                            selectedServices.map((service, index) => {
                                if (selectedServices?.length == index + 1) {
                                    return <span>{service}</span>
                                }
                                else{
                                    return <span>{service + ' , '}</span>
                                }
                                
                            })
                            :
                            'No service selected'
                    }
                    {/* {selectedServices ? selectedServices : 'No'}
                services selected */}
                </p>
                <FaAngleDown className='text-gray-400' />
            </div>
            {servicesCustomError && <p className='text-[#f33d3d]'>Services is required</p>}
            <SubServicesFilters
                servicesModal={servicesOpen}
                setServicesModal={setServicesOpen}
                advanceFiltersValueHandler={advanceFiltersValueHandler}
                isRadius={false}
                selectedData={props?.selectedFiltersValue && props?.selectedFiltersValue}
                data={props?.spServicesData && props?.spServicesData}
            />
        </>
    )
}

export default ServicesCustomSelectBox